import { render, staticRenderFns } from "./BmvModal.vue?vue&type=template&id=2c1021d2&scoped=true"
import script from "./BmvModal.vue?vue&type=script&lang=js"
export * from "./BmvModal.vue?vue&type=script&lang=js"
import style0 from "./BmvModal.vue?vue&type=style&index=0&id=2c1021d2&prod&lang=css"
import style1 from "./BmvModal.vue?vue&type=style&index=1&id=2c1021d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1021d2",
  null
  
)

export default component.exports